import { Bot, Globe, Settings2, Shovel, Users, Users2, Workflow } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { cn } from "../lib/utils";
import { GlobalDefaultsPage } from "./settings/global-defaults";
import { PropertyTypesPage } from "./settings/property-types";
import { SubsoilOptionsPage } from "./settings/subsoil-options";
import { UsersPage } from "./settings/users";
import { ValuersPage } from "./settings/valuers";
import { WhatAiKnowsPage } from "./settings/what-ai-knows";
import { WorkflowsPage } from "./settings/workflows";

const tabs = [
  { path: "/settings", label: "Property Types", icon: Globe, end: true },
  { path: "/settings/subsoil-options", label: "Subsoil Options", icon: Shovel, end: false },
  { path: "/settings/valuers", label: "Valuers", icon: Users, end: false },
  { path: "/settings/defaults", label: "Global Defaults", icon: Settings2, end: false },
  { path: "/settings/users", label: "Users", icon: Users2, end: false },
  { path: "/settings/what-the-ai-knows", label: "AI Context", icon: Bot, end: false },
  { path: "/settings/workflows", label: "Workflows", icon: Workflow, end: false },
];

export function SettingsPage(): React.ReactElement {
  const location = useLocation();
  const path = location.pathname;

  let content: React.ReactElement;
  if (path === "/settings/subsoil-options") content = <SubsoilOptionsPage />;
  else if (path === "/settings/valuers") content = <ValuersPage />;
  else if (path === "/settings/defaults") content = <GlobalDefaultsPage />;
  else if (path === "/settings/users") content = <UsersPage />;
  else if (path === "/settings/what-the-ai-knows") content = <WhatAiKnowsPage />;
  else if (path === "/settings/workflows") content = <WorkflowsPage />;
  else content = <PropertyTypesPage />;

  return (
    <div className="space-y-3">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Settings</h1>
        <p className="text-sm text-muted-foreground">Manage lookups, defaults, and user accounts</p>
      </div>
      <div className="flex gap-1 border-b">
        {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            end={tab.end}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors",
                isActive
                  ? "border-primary text-primary"
                  : "border-transparent text-muted-foreground hover:text-foreground",
              )
            }
            data-testid={`settings-tab-${tab.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <tab.icon className="h-4 w-4" />
            {tab.label}
          </NavLink>
        ))}
      </div>
      <div className="pt-2">{content}</div>
    </div>
  );
}
